<template>
  <div class="product-carousel">
    <!-- swiper -->
    <swiper :options="swiperOption">
      <swiper-slide
        v-for="product in products"
        :key="product.id"
      >
        <ProductTeaser :product="product" />
      </swiper-slide>

      <button
        slot="button-prev"
        class="swiper-button-prev"
        :aria-label="$modeoL10n.previous"
      />
      <button
        slot="button-next"
        class="swiper-button-next"
        :aria-label="$modeoL10n.next"
      />
    </swiper>
  </div>
</template>

<script>
import ProductTeaser from './product-teaser.vue';

export default {
    components: {
        ProductTeaser,
    },
    props: {
        products: {
            type: Array,
            default: function () {
                return [];
            },
        },
    },
    data() {
        return {
            swiperOption: {
                slidesPerView: 5,
                spaceBetween: 0,
                // init: false,
                prevButton: '.swiper-button-prev',
                nextButton: '.swiper-button-next',
                breakpoints: {
                    1600: {
                        slidesPerView: 5,
                    },
                    1400: {
                        slidesPerView: 4,
                    },
                    1150: {
                        slidesPerView: 3,
                    },
                    860: {
                        slidesPerView: 2,
                    },
                    600: {
                        slidesPerView: 1,
                    },
                },
            },
        }
    },
    methods: {

    },
}
</script>
